'use client'
import GoogleReview from "@/components/GoogleReview"
import { Player } from "@lottiefiles/react-lottie-player"
import { PrismicLink, PrismicRichText } from "@prismicio/react"
import React, { useEffect, useRef } from "react"

/**
 * @typedef {import("@prismicio/client").Content.HeroHomepageSlice} HeroHomepageSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroHomepageSlice>} HeroHomepageProps
 * @param {HeroHomepageProps}
 */
const HeroHomepageMobile = ({ slice, }) => {
  return <React.Fragment>
    <section id="hero" className="bg-light-pink relative">
      <div className="relative z-[10] pt-32 pb-12 px-4">
        <div className="relative text-dark-grey mb-6 max-w-[400px] mx-auto">
          <div className="ml-[115px]">
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div className="-mt-[54px] h-[237px] w-fit">
            <Player
              id="home-asset"
              className="w-[237px] h-auto inline-block"
              autoplay
              loop={true}
              mode="normal"
              src="/anim/anim-pictos-hero-mobile.json">
            </Player>
            <div></div>
          </div>
          <div className="absolute right-0 bottom-0">
            <GoogleReview note={slice.primary.note} picto={slice.primary.picto} />
          </div>
        </div>
        <div className="text-dark-grey">
          <div className="text-highlight mb-5">
            <PrismicRichText field={slice.primary.text} />
          </div>
          <div className="max-w-[400px] m-auto">
            <PrismicLink
              field={slice.primary.cta_page}
              className="button button-br-left button-text text-center bg-white py-2 px-3 w-full cta_form">{slice.primary.cta_label}</PrismicLink>
          </div>
        </div>
      </div>
      <div className="absolute overflow-x-hidden w-screen top-0 md:top-[844px]">
        <div id="coulure-home-hero" className="w-screen relative">
          <Player
            id="home-coulure"
            autoplay
            keepLastFrame
            src="/anim/coulure-hero-home-mobile.json">
          </Player>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>

    </section >
  </React.Fragment >

}

const HeroHomepageDesktop = ({ slice, context }) => {

  const ref = useRef(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      let topCoulure;
      if (window.innerWidth >= 768 && window.innerWidth <= 1024 ){
        topCoulure = 0
      } 
      if (window.innerWidth > 1024 && window.innerWidth < 1280) topCoulure = window.innerWidth - 1024
      if (window.innerWidth >= 1280) topCoulure = window.innerWidth - 1280
      ref.current.style.top = `-${topCoulure / 1.5}px`;
    }
  })

  return <React.Fragment>
    <section id="hero"
      className="block bg-light-pink lg:pt-[156px] pt-32 pb-16 lg:pb-32 m-auto relative">
      <div className="flex justify-center text-dark-grey relative z-[10]">
        <div className="xl:-ml-[160px] h-[336px] w-auto lg:w-[395px]">
          <div className="flex justify-end h-[336px]">
            <Player
              id="home-picto"
              className="w-[224px] h-auto"
              loop={true}
              autoplay
              src="anim/anim-pictos-hero.json">
            </Player>
          </div>
          <div className="mt-30px mr-[35px] hidden lg:block">
            <div className="button button-br-left overflow-hidden background-slide-white">
              <PrismicLink field={slice.primary.cta_page} className="button-text cta_form">
                {slice.primary.cta_label}</PrismicLink>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-[500px] lg:w-[600px]">
          <div className="-ml-[2px]">
            <div className="flex">
              <span className="mt-[112px]">
                <img src="svg/picto-hero-paintroll.svg" className="w-[113px] h-[113px]" alt="picto"/>
              </span>
              <div className="-ml-[80px]">
                <PrismicRichText field={slice.primary.title} />
              </div>
            </div>
          </div>
          <div className="-ml-[2px] mt-px flex items-center pb-4">
            <span className="-mt-[6px]">
              <img src="svg/picto-hero-scene.svg" className="w-[113px] h-[113px]" alt="picto"/>
            </span>
            {/* <h2 className="pl-30px flex flex-row items-center"><span className="mr-2">À</span><span id="text-target"
              data-ville="<%- slice.items.map(item => item.text_localisation).join(',') %>"></span><span
                className="cursor"></span> </h2> */}
            <PrismicRichText field={slice.primary.extra_text} components={{
              paragraph: ({ children }) => <h2 className="pl-30px flex flex-row items-center mr-2 flex-1 h2">{children}</h2>,
            }} />


          </div>
          <div className="text-highlight max-w-[500px]">
            <PrismicRichText field={slice.primary.text} />
          </div>
        </div>
        <GoogleReview className='absolute right-30px -bottom-[150px] lg:-bottom-[66px] flex' note={slice.primary.note} picto={slice.primary.picto} />
      </div>
      <div className="lg:hidden m-[40px] relative z-[10]">
        <div className="button button-br-left overflow-hidden background-slide-white">
          <PrismicLink field={slice.primary.cta_page} className="button-text">{slice.primary.cta_label}</PrismicLink>
        </div>
      </div>
      <div ref={ref} className="absolute overflow-x-hidden w-screen md:top-coulure-md lg:top-coulure-lg">
        <div id="coulure-home-hero" className="w-screen relative">
          <Player
            id="home-coulure"
            autoplay
            keepLastFrame
            src={context.isTabletViewer ? "/anim/coulure-hero-home-mobile.json" : "/anim/coulure-hero-home-desktop.json"}>
          </Player>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section >
  </React.Fragment >


}

const HeroHomepage = ({ slice, context }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}>
      {context.isMobileViewer ? <HeroHomepageMobile slice={slice} /> : <HeroHomepageDesktop slice={slice} context={context} />}
    </section>
  );
};

export default HeroHomepage;
